export default () => {
  window.googletag.pubads().setPrivacySettings({
    limitedAds: true
  });
};
